<script setup lang="ts">
import { useRenderStore } from '@/builder/stores/renderStore';
import { MerchantType, PaymentMethodType } from '@/enums';
import TestPaymentsCard from "./TestPaymentsCard.vue"
import TestPaymentsAch from "./TestPaymentsAch.vue"

const renderStore = useRenderStore();

const morePaymentMethodsUrl = renderStore.page.merchantType === MerchantType.StripeUnified
    ? "https://docs.stripe.com/testing#cards"
    : "https://developer.authorize.net/hello_world/testing_guide.html"

</script>

<template>
    <section class="test-mode-banner-container test-payment-types"
        :class="{ '!rd-mb-5': renderStore.page.merchantType === MerchantType.AuthorizeNet }">
        <div class="test-mode-banner-top w-full"></div>
        <div class="rd-items-start rd-flex rd-flex-col rd-justify-center rd-w-full test-mode-banner-content">
            <div
                class="rd-items-center rd-flex rd-flex-row rd-justify-between rd-mb-4 rd-w-full sm-max:rd-flex-col sm-max:rd-items-start">
                <span class="rd-flex rd-text-xs rd-font-semibold rd-leading-none rd-uppercase sm-max:rd-mb-2">
                    Test Payment Types
                </span>
                <span class="rd-items-center rd-flex rd-text-xs">
                    <a class="more-methods rd-font-medium" :href="morePaymentMethodsUrl" target="_blank">
                        More Test Payment Methods
                    </a>
                    <i class="fa-solid fa-arrow-right rd-ml-1"></i>
                </span>
            </div>
            <TestPaymentsCard
                v-if="renderStore.gift.paymentMethodType == PaymentMethodType.Credit || renderStore.page.merchantType === MerchantType.StripeUnified" />
            <TestPaymentsAch
                v-if="renderStore.gift.paymentMethodType == PaymentMethodType.ACH && renderStore.page.merchantType === MerchantType.AuthorizeNet" />
        </div>
    </section>
</template>
